"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var calculatePercentage = function calculatePercentage(amount, originalAmount) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "de-DE";
  if (!amount || !originalAmount) return;
  var percentage = -parseInt(Math.round(100 - amount / (originalAmount / 100)));
  return new Intl.NumberFormat(locale, {
    signDisplay: "exceptZero"
  }).format(percentage);
};
var _default = calculatePercentage;
exports.default = _default;